module.exports = __webpack_public_path__ + "img/PDF.f864ed90.png";